export { SnapHotspot } from './SnapHotspot';
